import round from 'lodash/round';

export const formatAsPctString = (value: number, precision = 2): string => `${round((value || 0) * 100, precision)}%`;
